import * as React from "react";
import "../../style/App.css";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import ProfileInfo from "../profileTop/profileInfo";
import { getVal /*firebaseConnect*/ } from "react-redux-firebase";
import { searchProfile } from "src/store/actions/searchAction";
// import HighFive from './HighFive/highfive';

export interface Props {
  auth: any;
  history: any;
}

class Profile extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { auth } = this.props;
    if (auth?.uid) {
      this.props.history.push("/profile/" + auth?.uid);
    }
    return <div></div>;
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose<any>(connect(mapStateToProps))(Profile);



// WEBPACK FOOTER //
// ./src/components/screens/profile.tsx